import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../../Components/ErrorContainer";
import BuyAssets from "./BuyAssets";
import { getFormData } from "../../../../helpers";
import OutstandingInvoices from "./OutstandingInvoices";

const LinkedInvoices = ({
  linkedInvoicesState,
  setLinkedInvoicesState,
  pageType,
  viewFormOptions,
}) => {
  const invoicesData = useSelector(
    (state) => state?.financeReducer?.invoicesData?.invoice_data
  );

  function handleSelectAllItems() {
    console.log(
      linkedInvoicesState,
      linkedInvoicesState?.isAllSelected,
      "pppppp"
    );
    if (linkedInvoicesState?.isAllSelected) {
      setLinkedInvoicesState({
        isAllSelected: false,
        selectedItemId: [],
        totalAmount: 0,
      });
    } else {
      setLinkedInvoicesState({
        isAllSelected: true,
        selectedItemId: invoicesData?.map((el) => el.id),
        totalAmount: invoicesData?.reduce(
          (outerAcc, outerCurr) =>
            outerAcc +
            outerCurr?.payment?.reduce(
              (innerAcc, innerCurr) => innerAcc + innerCurr?.amount,
              0
            ),
          0
        ),
      });
    }
  }

  function handleSingleItem(targetEl, invoicesData, linkedInvoicesState) {
    const copiedSelectedItemId = [...linkedInvoicesState?.selectedItemId];
    const targetAmountSum = targetEl?.payment?.reduce(
      (acc, curr) => acc + curr.amount,
      0
    );
    const targetIndex = copiedSelectedItemId?.findIndex(
      (itemId) => itemId == targetEl.id
    );

    // if target El is not checked
    if (targetIndex === -1) {
      const isAllSelected =
        invoicesData?.length - 1 ===
        linkedInvoicesState?.selectedItemId?.length;
      console.log(
        isAllSelected,
        "isAllSelected",
        invoicesData?.length,
        linkedInvoicesState?.selectedItemId?.length
      );
      copiedSelectedItemId.push(targetEl?.id);
      setLinkedInvoicesState({
        isAllSelected: isAllSelected,
        selectedItemId: copiedSelectedItemId,
        totalAmount: linkedInvoicesState?.totalAmount + targetAmountSum,
      });
    } else {
      // if it is already checked
      copiedSelectedItemId?.splice(targetIndex, 1);
      setLinkedInvoicesState({
        isAllSelected: false,
        selectedItemId: copiedSelectedItemId,
        totalAmount: linkedInvoicesState?.totalAmount - targetAmountSum,
      });
    }
    // }
  }

  function getHtml(pageType) {
    const payments = viewFormOptions?.payments;
    if (pageType === "viewPayment") {
      return (
        <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
          <h4 className="event-alert w-100 mb-0">Linked Invoices</h4>

          <div className="row col-12 mx-0">
            <table className="checklist-table remove-space inventory_table">
              <thead>
                <tr>
                  <th>Date/Time</th>
                  <th>Invoice ID</th>
                  {viewFormOptions?.isShowLinkedData && <th>Account</th>}
                  <th>Description</th>
                  <th>Amount </th>
                  <th>Paid Now </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{payments?.invoice_date}</td>
                  <td>{payments?.invoice?.invoice_number}</td>
                  {viewFormOptions?.isShowLinkedData && (
                    <td>{payments?.merchant?.account_name}</td>
                  )}
                  <td>{payments?.invoice?.memo}</td>
                  <td>{payments?.invoice?.total_price}</td>
                  <td>{payments?.amount}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }
    if (pageType === "editPayment") {
      return (
        <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
          <h4 className="event-alert w-100 mb-0">Linked Invoices</h4>

          <div className="row col-12 mx-0">
            <table className="checklist-table remove-space inventory_table">
              <thead>
                <tr>
                  <th width="">
                    <a class="checkbox avaiCheck">
                      <div class="input checkbox">
                        <input
                          onClick={() => {
                            handleSelectAllItems();
                          }}
                          type="checkbox"
                          value="1"
                          id="select_all"
                          checked={linkedInvoicesState?.isAllSelected}
                        />
                        <label for="select_all"></label>
                      </div>
                    </a>
                  </th>
                  <th>Date/Time</th>
                  <th>Invoice ID</th>
                  <th>Description</th>
                  <th>Amount </th>
                  <th>Paid Now </th>
                </tr>
              </thead>
              <tbody>
                {invoicesData?.map((el, idx) => (
                  <tr>
                    <td width="">
                      <a class="checkbox avaiCheck">
                        <div class="input checkbox">
                          <input
                            onClick={() =>
                              handleSingleItem(
                                el,
                                invoicesData,
                                linkedInvoicesState
                              )
                            }
                            type="checkbox"
                            value="1"
                            id={`select_all_${idx}`}
                            checked={
                              !!linkedInvoicesState?.selectedItemId?.find(
                                (id) => id == el?.id
                              )
                            }
                          />
                          <label for={`select_all_${idx}`}></label>
                        </div>
                      </a>
                    </td>
                    <td>{el?.invoice_date}</td>
                    <td>{el?.invoice_ID}</td>
                    <td>{el?.memo}</td>
                    <td>
                      {el?.payment?.reduce(
                        (acc, curr) => acc + curr?.amount,
                        0
                      )}
                    </td>
                    <td>
                      {el?.payment?.reduce(
                        (acc, curr) => acc + curr?.amount,
                        0
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );

      return (
        <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
          <h4 className="event-alert w-100 mb-0">Linked Invoices</h4>

          <div className="row col-12 mx-0">
            <table className="checklist-table remove-space inventory_table">
              <thead>
                <tr>
                  <th width="">
                    <a class="checkbox avaiCheck">
                      <div class="input checkbox">
                        <input
                          onClick={() => {
                            handleSelectAllItems();
                          }}
                          type="checkbox"
                          value="1"
                          id="select_all"
                          checked={linkedInvoicesState?.isAllSelected}
                        />
                        <label for="select_all"></label>
                      </div>
                    </a>
                  </th>
                  <th>Date/Time</th>
                  <th>Invoice ID</th>
                  <th>Description</th>
                  <th>Amount </th>
                  <th>Paid Now </th>
                </tr>
              </thead>
              <tbody>
                {invoicesData?.map((el, idx) => (
                  <tr>
                    <td width="">
                      <a class="checkbox avaiCheck">
                        <div class="input checkbox">
                          <input
                            onClick={() =>
                              handleSingleItem(
                                el,
                                invoicesData,
                                linkedInvoicesState
                              )
                            }
                            type="checkbox"
                            value="1"
                            id={`select_all_${idx}`}
                            checked={
                              !!linkedInvoicesState?.selectedItemId?.find(
                                (id) => id == el?.id
                              )
                            }
                          />
                          <label for={`select_all_${idx}`}></label>
                        </div>
                      </a>
                    </td>
                    <td>{el?.invoice_date}</td>
                    <td>{el?.invoice_ID}</td>
                    <td>{el?.memo}</td>
                    <td>
                      {el?.payment?.reduce(
                        (acc, curr) => acc + curr?.amount,
                        0
                      )}
                    </td>
                    <td>
                      {el?.payment?.reduce(
                        (acc, curr) => acc + curr?.amount,
                        0
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
    return (
      <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
        <h4 className="event-alert w-100 mb-0">Linked Invoices</h4>

        <div className="row col-12 mx-0">
          <table className="checklist-table remove-space inventory_table">
            <thead>
              <tr>
                <th width="">
                  <a class="checkbox avaiCheck">
                    <div class="input checkbox">
                      <input
                        onClick={() => {
                          handleSelectAllItems();
                        }}
                        type="checkbox"
                        value="1"
                        id="select_all"
                        checked={linkedInvoicesState?.isAllSelected}
                      />
                      <label for="select_all"></label>
                    </div>
                  </a>
                </th>
                <th>Date/Time</th>
                <th>Invoice ID</th>
                <th>Description</th>
                <th>Amount </th>
                <th>Paid Now </th>
              </tr>
            </thead>
            <tbody>
              {invoicesData?.map((el, idx) => (
                <tr>
                  <td width="">
                    <a class="checkbox avaiCheck">
                      <div class="input checkbox">
                        <input
                          onClick={() =>
                            handleSingleItem(
                              el,
                              invoicesData,
                              linkedInvoicesState
                            )
                          }
                          type="checkbox"
                          value="1"
                          id={`select_all_${idx}`}
                          checked={
                            !!linkedInvoicesState?.selectedItemId?.find(
                              (id) => id == el?.id
                            )
                          }
                        />
                        <label for={`select_all_${idx}`}></label>
                      </div>
                    </a>
                  </td>
                  <td>{el?.invoice_date}</td>
                  <td>{el?.invoice_ID}</td>
                  <td>{el?.memo}</td>
                  <td>
                    {el?.payment?.reduce((acc, curr) => acc + curr?.amount, 0)}
                  </td>
                  <td>
                    {el?.payment?.reduce((acc, curr) => acc + curr?.amount, 0)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return <>{getHtml(pageType)}</>;
};

export default LinkedInvoices;
